import { LoginOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Menu as AntMenu, Button, Col, Dropdown, Tooltip } from 'antd'
import {
  PERM_ADULT_DOUBLES_ADMIN,
  PERM_ADULT_LESSONS_ADMIN,
  PERM_JUNIOR_CAMPS,
  PERM_MESSAGES_ADMIN,
  PERM_REGISTRATIONS,
  hasAnyAdminPermission,
  hasPermission,
} from '../../util/authUtil'

import { useContext } from 'react'
import { Link } from 'react-router-dom'
import useResponsive from '../../hooks/useResponsive'
import AppContext from './AppContext'

const ProfileMenu = ({ onShowLogin }) => {
  const { loginInProgress, currentUser, logout, setLoginAsVisible } = useContext(AppContext)
  const bp = useResponsive()
  const showAdminMenu = hasAnyAdminPermission(currentUser)

  const size = bp.xxl ? 'xxl' : bp.xl ? 'xl' : bp.lg ? 'lg' : bp.md ? 'md' : bp.sm ? 'sm' : 'xs'

  const tooltipText = currentUser
    ? `You're logged in as ${currentUser.firstName} ${currentUser.lastName ?? ''}`
    : 'Login'

  const menu = (
    <AntMenu selectable={false} id="profile" style={{ minWidth: '15em', zIndex: '100' }}>
      <AntMenu.Item key="profile" icon={<UserOutlined />}>
        <Link to="/profile">My profile</Link>
      </AntMenu.Item>
      {showAdminMenu && (
        <>
          <AntMenu.Divider />
          <AntMenu.ItemGroup key="admin" title="Admin">
            {currentUser?.username === 'mason.doerr@gmail.com' && (
              <AntMenu.Item key="login-as-other-user">
                <Link to="#" onClick={() => setLoginAsVisible(true)}>
                  Login as other user
                </Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_MESSAGES_ADMIN) && (
              <AntMenu.Item key="messages">
                <Link to="/admin/messages">Messages</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_REGISTRATIONS) && (
              <AntMenu.Item key="users">
                <Link to="/admin/users">Members</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_REGISTRATIONS) && (
              <AntMenu.Item key="registrations">
                <Link to="/admin/registrations">Registrations</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_JUNIOR_CAMPS) && (
              <AntMenu.Item key="camp-signups">
                <Link to="/admin/camp-signups">Camp signups</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_JUNIOR_CAMPS) && (
              <AntMenu.Item key="adv-camp-signups">
                <Link to="/admin/adv-camp-signups">Junior adv. lesson signups</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_ADULT_LESSONS_ADMIN) && (
              <AntMenu.Item key="adult-lesson-signups">
                <Link to="/admin/adult-lesson-signups">Adult lesson signups</Link>
              </AntMenu.Item>
            )}
            {hasPermission(currentUser, PERM_ADULT_DOUBLES_ADMIN) && (
              <AntMenu.Item key="adult-doubles-signups">
                <Link to="/admin/adult-doubles-signups">Adult doubles signups</Link>
              </AntMenu.Item>
            )}
          </AntMenu.ItemGroup>
        </>
      )}
      <AntMenu.Divider />
      <AntMenu.Item key="logout" icon={<LogoutOutlined />}>
        <Link to="/" onClick={logout}>
          Logout
        </Link>
      </AntMenu.Item>
    </AntMenu>
  )

  const dropdown = (
    <Dropdown overlay={menu} trigger={['click']}>
      <Tooltip title={tooltipText} placement="left">
        <Button icon={<UserOutlined className="menuIcon" />} type="link">
          {/* {size}  */}
          {bp.xsOrSm ? '' : `${currentUser?.firstName || currentUser?.username}`}
        </Button>
      </Tooltip>
    </Dropdown>
  )
  const login = (
    <Button icon={<LoginOutlined className="menuIcon" />} type="link" onClick={onShowLogin}>
      {bp.xsOrSm ? '' : 'Login'}
    </Button>
  )

  const result = loginInProgress ? null : currentUser ? dropdown : login

  return <Col className="menuItem">{result}</Col>
}

export default ProfileMenu
